import { BottomCTA } from '@/components/dating/BottomCTA';
import { Hero } from '@/components/dating/Hero';
import { Protected } from '@/components/dating/Protected';
import { Reviews } from '@/components/dating/Reviews';
import { Video } from '@/components/dating/Video';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/dating/us/en';
import { Box } from '@lemonade-hq/cdk';
import { useEffect } from 'react';

export default function DatingPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('renters_page.viewed', {
        variant: 'default',
      }),
    [],
  );

  return (
    <Box position="relative" overflowX="hidden">
      <Layout headerActions={config.layout.headerActions}>
        <SEO {...config.seo} />
        <PageWrapper>
          <Hero {...config.hero} />
          <Protected {...config.protected} />
          <Reviews {...config.customersReviews} />
          <Video {...config.video} />
          <BottomCTA {...config.bottomCta} />
        </PageWrapper>
      </Layout>
    </Box>
  );
}
